import { render, staticRenderFns } from "./preliminary_raceManagement.vue?vue&type=template&id=22c0cb78&scoped=true&"
import script from "./preliminary_raceManagement.vue?vue&type=script&lang=js&"
export * from "./preliminary_raceManagement.vue?vue&type=script&lang=js&"
import style0 from "./preliminary_raceManagement.vue?vue&type=style&index=0&id=22c0cb78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0cb78",
  null
  
)

export default component.exports